import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/common/index.vue'

/**
 * 重写路由的push方法
 * 解决，相同路由跳转时，报错
 * 添加，相同路由跳转时，触发watch (针对el-menu，仅限string方式传参，形如"view?id=5")
 */
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/common/login')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/common/register')
  },
  {
    path: '/find_password',
    name: 'FindPassword',
    component: () => import('../views/common/find_password')
  },
  {
    path: '/art_info',
    name: 'ArtInfo',
    component: () => import('../views/art_info'),
  },
  {
    path: '/art_info/detail',
    name: 'ArtInfo_detail',
    component: () => import('../views/art_info/detail')
  },
  {
    path: '/match',
    name: 'Match',
    component: () => import('../views/match')
  },
  {
    path: '/match/match_works',
    name: 'MatchWorks',
    component: () => import('../views/match/match_works')
  },
  {
    path: '/match/match_detail',
    name: 'MatchDetail',
    component: () => import('../views/match/match_detail')
  },
  {
    path: '/match/match_top',
    name: 'MatchTop',
    component: () => import('../views/match/match_top')
  },
  {
    path: '/match/work_detail',
    name: 'WorkDetail',
    component: () => import('../views/match/work_detail')
  },
  {
    path: '/match/edit_work',
    name: 'EditWork',
    component: () => import('../views/match/edit_work')
  },
  {
    path: '/match/join_match',
    name: 'JoinMatch',
    component: () => import('../views/match/join_match')
  },
  {
    path: '/match/upload_work',
    name: 'UploadWork',
    component: () => import('../views/match/upload_work')
  },
  {
    path: '/match/work_grade',
    name: 'WorkGrade',
    component: () => import('../views/match/work_grade')
  },
  {
    path: '/expert',
    name: 'Expert',
    component: () => import('../views/expert')
  },
  {
    path: '/expert/expert_upload',
    name: 'ExpertUpload',
    component: () => import('../views/expert/expert_upload')
  },
  {
    path: '/expert/select_expert',
    name: 'SelectExpert',
    component: () => import('../views/expert/select_expert')
  },
  {
    path: '/art_museum',
    name: 'ArtMuseum',
    component: () => import('../views/art_museum')
  },
  {
    path: '/contactUs',
    name: 'ContactUs',
    component: () => import('../views/contact/contactUs')
  }
  ,
  {
    path: '/user',
    name: 'User',
    component: () => import('../views/user')
  }
  ,
  {
    path: '/user/visit',
    name: 'UserVisit',
    component: () => import('../views/user/visit')
  },
  {
    path: '/user/edit_data',
    name: 'UserEditData',
    component: () => import('../views/user/edit_data')
  },
  {
    path: '/user/edit_password',
    name: 'UserEditPwd',
    component: () => import('../views/user/edit_password')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})


// router.beforeEach((to, from, next) => {
//   console.log(to, from, next);
//   next();
// })

export default router
